(function($) {

    $.fn.toggleButton = function(options) {
        var el = this,
            defaults = {
                activeClass: 'active',
                toggleAction: $.noop,
                isActive: false,
                activeTitle: 'Turn Off',
                inactiveTitle: 'Turn On'
            },
            settings = $.extend(defaults, options);

        settings.isActive &&
            this.addClass(settings.activeClass);

        this.attr('title', settings.isActive
            ? settings.activeTitle
            : settings.inactiveTitle
        );

        this.on('click', doToggle);

        // Programatic way to trigger the toggle
        this.on('toggle', doToggle);

        /* untoggles without calling the toggle action */
        this.on('toggleOff', function() {
            $(this)
                .removeClass( settings.activeClass )
                .attr('title', settings.inactiveTitle);
        });

        /* toggles on without calling the default action */
        this.on('toggleOn', function() {
            $(this)
                .addClass( settings.activeClass )
                .attr('title', settings.activeTitle);
        });

        function doToggle() {
            el.toggleClass(settings.activeClass);
            toggleTitle();
            settings.toggleAction();
        }

        function toggleTitle() {

            el.attr( 'title', el.attr('title') === settings.activeTitle
                ? settings.inactiveTitle
                : settings.activeTitle
            );

            return el;
        }

        this.destroy = function() {
            el.remove();
        };

        return this;

    };


})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/toggleButton.js
 ** module id = 516
 ** module chunks = 0
 **/